import "./index.css";
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useDispatch } from "react-redux";
import { getLocalUser } from "./3- actions/users";

import BadgesSystem from "./BadgesSystem/BadgesSystem";
import Nav from "./components/Nav & Header/Nav";
import Footer from "./components/Footer/Footer";
import Home from "./Home/Home";
import Browse from "./Browse/Browse";
import Favorites from "./Favorites/Favorites";
import Create from "./Create/Create";
import NotFound from "./404/NotFound";
import NovelPage from "./NovelPage/NovelPage";
import UserNovels from "./UserNovels/UserNovels";
import NovelChapPage from "./NovelChapPage/NovelChapPage";
import ChapFooter from "./components/Footer/ChapFooter";
import Music from "./components/Music/Music";
import EyeNoData from "./components/Nav & Header/EyeNoData";

function App() {
  const dispatch = useDispatch();
  const [popup, setPopUp] = useState(false);
  const [interfaces, setInterfaces] = useState(0);
  const userId = JSON.parse(localStorage.getItem("profile"))?.result?._id;

  useEffect(() => {
    // get my localStorage user
    if (userId) {
      dispatch(getLocalUser(userId));
    }
    // show modal in 10 min after mounted
    if (!userId) {
      const timer = setTimeout(() => {
        setPopUp(true);
      }, 600000);
      // clear timer if the component unmount
      return () => clearTimeout(timer);
    }
  }, [dispatch, userId]);

  // ScrollToTop function
  function ScrollToTop() {
    const { pathname } = useLocation();

    React.useEffect(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }, [pathname]);

    return null;
  }

  // opening animation logic
  const [loadingOpening, setLoadingOpening] = React.useState(true);
  const [loadingContent, setisLoadingContent] = React.useState(true);
  const controls = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    const timeId = setTimeout(() => setLoadingOpening(false), 3300);
    return () => clearTimeout(timeId);
  }, []);
  useEffect(() => {
    const timeId = setTimeout(() => setisLoadingContent(false), 3300);
    return () => clearTimeout(timeId);
  }, []);

  useEffect(() => {
    if (inView) {
      controls.start("show");
    }
    if (!inView) {
      controls.start("hidden");
    }
  }, [controls, inView]);
  const loadingEffe = {
    hidden: {
      opacity: 0,
      scale: 0,
      x: "-50%",
      y: "-50%",
      top: "50%",
      left: "50%",
    },
    show: {
      opacity: 1,
      scale: 1,
      rotate: [0, 45, 90, 0, 0],
      x: "-50%",
      y: "-50%",
      top: "50%",
      left: "50%",
      transition: {
        ease: [0.6, 0.01, -0.05, 1.5],
        duration: 2.5,
      },
    },
  };
  const background = {
    hidden: {
      opacity: 1,
      scale: 0,
      x: "-50%",
      y: "-50%",
      top: "50%",
      left: "50%",
    },
    show: {
      opacity: 1,
      scale: [1, 1, 1, 10],
      borderRadius: ["50%", "0%", "0%", "0%"],
      rotate: [0, 0, 0, 180],
      x: "-50%",
      y: "-50%",
      top: "50%",
      left: "50%",
      transition: {
        ease: [0.6, 0.01, -0.05, 0.5],
        duration: 2.5,
      },
    },
  };

  return (
    <div>
      {/* opening animation */}
      {loadingOpening && (
        <motion.div className="z-[10000000000] fixed inset-0 ">
          <motion.div
            variants={background}
            initial="hidden"
            animate={controls}
            ref={ref}
            className="bg-primary rounded-full w-[50vw] h-[50vw]  md:w-[40vw] md:h-[40vw] lg:w-[30vw] lg:h-[30vw] xl:w-[25vw] xl:h-[25vw] scale-50 duration-500 ease-in-out absolute "
          ></motion.div>
          <motion.div
            variants={loadingEffe}
            initial="hidden"
            animate={controls}
            ref={ref}
            className="absolute openingzoom"
          >
            <EyeNoData />
          </motion.div>
        </motion.div>
      )}
      {/* Pages */}
      <div
        className={
          !loadingContent
            ? "md:mx-8 opacity-1 duration-1000 ease-in-out"
            : "md:mx-8 opacity-0 duration-1000 ease-in-out"
        }
      >
        <Router>
          <ScrollToTop />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Nav
                    interfaces={interfaces}
                    setInterfaces={setInterfaces}
                    popup={popup}
                    setPopUp={setPopUp}
                  />
                  <Home setInterfaces={setInterfaces} setPopUp={setPopUp} />
                  <Footer />
                </>
              }
            />
            <Route
              path="/browse"
              element={
                <>
                  <Nav
                    interfaces={interfaces}
                    setInterfaces={setInterfaces}
                    popup={popup}
                    setPopUp={setPopUp}
                  />
                  <Browse />
                  <Footer />
                </>
              }
            />
            <Route
              path="/create"
              element={
                <>
                  <Nav
                    interfaces={interfaces}
                    setInterfaces={setInterfaces}
                    popup={popup}
                    setPopUp={setPopUp}
                  />
                  <Create
                    interfaces={interfaces}
                    setInterfaces={setInterfaces}
                    popup={popup}
                    setPopUp={setPopUp}
                  />
                  <Footer />
                </>
              }
            />
            <Route
              path="/favorites"
              element={
                <>
                  <Nav
                    interfaces={interfaces}
                    setInterfaces={setInterfaces}
                    popup={popup}
                    setPopUp={setPopUp}
                  />
                  <Favorites />
                  <Footer />
                </>
              }
            />
            <Route
              path="/badgesSystem"
              element={
                <>
                  <Nav
                    interfaces={interfaces}
                    setInterfaces={setInterfaces}
                    popup={popup}
                    setPopUp={setPopUp}
                  />
                  <BadgesSystem />
                  <Footer />
                </>
              }
            />
            <Route
              path="/novels/:id"
              element={
                <>
                  <Nav
                    interfaces={interfaces}
                    setInterfaces={setInterfaces}
                    popup={popup}
                    setPopUp={setPopUp}
                  />
                  <NovelPage
                    setInterfaces={setInterfaces}
                    setPopUp={setPopUp}
                  />
                  <Footer />
                </>
              }
            />
            <Route
              path="/users/:id"
              element={
                <>
                  <Nav
                    interfaces={interfaces}
                    setInterfaces={setInterfaces}
                    popup={popup}
                    setPopUp={setPopUp}
                  />
                  <UserNovels
                    setInterfaces={setInterfaces}
                    setPopUp={setPopUp}
                  />
                  <Footer />
                </>
              }
            />
            <Route
              path="/novels/:id/:id"
              element={
                <>
                  <Nav
                    interfaces={interfaces}
                    setInterfaces={setInterfaces}
                    popup={popup}
                    setPopUp={setPopUp}
                  />
                  <NovelChapPage />
                  <ChapFooter />
                </>
              }
            />
            <Route
              path="notfound"
              element={
                <>
                  <NotFound />
                </>
              }
            />
            <Route
              path="*"
              element={
                <>
                  <NotFound />
                </>
              }
            />
          </Routes>
        </Router>
        <Music />
      </div>
    </div>
  );
}

export default App;
